/**
 * Tutor theme — le poste de travail du masteur sur la nuit (Brand core V16, « Clair et sombre, au
 * choix »). Le livre ne montre la nuit du tuteur qu'en vignette (p. 9, 14) : elle se dessine ici, de la
 * même façon que celle de l'élève.
 *
 * Le socle de la nuit (`nightBase.ts`), plus ce que l'univers du tuteur y devient : **il ne s'inverse
 * pas**. Le teal est une couleur, pas un ton de fond, comme l'orange de l'élève : le bouton reste
 * l'aplat teal à libellé blanc, l'option choisie aussi. Son ÉCRITURE et son AFFICHAGE bougent : posé
 * sur la nuit, le teal ne tient que 3,6 (page), 3,0 (carte) et 2,3 (encart), il s'éclaircit donc en
 * `#84B6C0` (8,1, 6,7 et 5,1) — là où l'orange de l'élève, plus clair, garde son affichage ; posé sur
 * la face blanche du secondaire, il reste celui du clair.
 */
import { baseTheme } from "./base"
import { nightBaseColors } from "./nightBase"
import { brand, night } from "./tokens/colors"

export const tutorDarkTheme = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        ...nightBaseColors,

        // L'affichage s'éclaircit aussi : un glyphe, un anneau, le liseré d'une case cochée au teal ne
        // tiennent que 2,3:1 sur un encart de la nuit, au teal éclairci 5,1 (`contrast.test.ts`).
        role: night.tutorInk,
        "role-strong": night.tutorInk,
        "role-fill": brand.roleTutor,
        "relief-role": brand.roleTutorShade,
        "danger-fill": brand.errorInk,
        "relief-danger": brand.errorInkShade,
        "text-on-role": brand.white,
        "text-on-secondary": brand.roleTutor,
        "text-link": night.tutorInk,
        "role-selected": brand.roleTutor,
        // Ce qui flotte (le rond « vers la fin » du chat) une marche au-dessus de la carte, comme sur la nuit
        // de l'élève : à la surface de la carte, il se confondait avec elle (1,00) et avec la page (1,20).
        "surface-floating": night.raised,
        // Les tintes de statut aplaties sur la carte où elles se posent, comme sur la nuit de l'élève.
        successLight: night.progressTintOnCard,
        warningLight: night.alertTintOnCard,
        dangerLight: night.errorTintOnCard,
        "text-success": night.progressInk,
        "text-warning": night.alertInk,
        "text-danger": night.errorInk,
        "text-phone": night.tutorInk,
        "text-purple": night.focusedInk,
        // La lueur n'est pas montée sur la nuit ; le jeton suit le clair pour la bascule d'« Apparence ».
        glow: brand.roleTutor,
    },
} as const
